import { Component, inject } from '@angular/core';
import { UIMode } from '@core/ui/ui.model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipDirective } from '@shared/directives/tooltip/tooltip.directive';
import { UIService } from '../../../../core/ui/ui.service';
import { ButtonGenericComponent } from '../button-generic/button-generic.component';

@Component({
    selector: 'app-theme-mode-button',
    imports: [FontAwesomeModule, ButtonGenericComponent, TooltipDirective],
    templateUrl: './theme-mode-button.component.html',
    styleUrl: './theme-mode-button.component.scss'
})
export class ThemeModeButtonComponent {
    uiService = inject(UIService);
    UIMode = UIMode;
    
    changeTheme(){
        this.uiService.changeTheme();
    }
}
